// extracted by mini-css-extract-plugin
export default {"shoaib":"modelModalContent_shoaib__wfdfH","imagesModal":"modelModalContent_imagesModal__6zfp+","slider":"modelModalContent_slider__C9zYZ"};